import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input } from "antd";
import { Link } from "react-router-dom";
function Footer1() {
	  const [email, setEmail] = useState("");


	const envoyerNew = async (e) => {
		e.preventDefault();

		try {
		  const response = await fetch(
			"http://localhost:8081/api/plateforme/email/liste",
			{
			  method: "POST",
			  headers: {
				"Content-Type": "application/json",
			  },
			  body: JSON.stringify({ emails: emailList }),
			}
		  );

		  if (!response.ok) {
			throw new Error(`Erreur HTTP: ${response.status}`);
		  }

		  openNotificationWithIcon("success", "Liste des emails envoyée avec succès !");
		} catch (error) {
		  openNotificationWithIcon("error", "Échec de l'envoi de la liste des emails.");
		}
	  };

    return (
        <footer1>

<div className="cta1">
<div
            className="hero1-bg bg-cover"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/bannerfooter.jpg)`,
            }}
          >
            <div className="container">
				<div className="row align-items-center">
					{/* Section Texte Newsletter */}
					<div className="">
						<div className="heading1-w text-center" >
							<h2 style={{marginTop: "67px"}}>Abonnez-vous à notre Newsletter</h2>
							<p className="mt-16">
								Ne manquez plus aucune information grâce à notre newsletter.
							</p>
							<div className="form-area" style={{ marginBottom: "30px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
								<form
									action="#"
									style={{
										display: "flex",
										alignItems: "center",
										borderRadius: "20px",
										backgroundColor: "white",
										padding: "5px",
										boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
									}}
								>
									<input
										type="email"
										placeholder="Votre adresse email"
										value={email}
																		style={{
											padding: "8px 12px",
											fontSize: "14px",
											width: "250px",
											border: "none",
											backgroundColor: "transparent",
											flexGrow: 1
										}}
									/>
									<button
										className="theme-btn1"
										style={{
											padding: "8px 16px",
											fontSize: "14px",
											borderRadius: "20px",
											backgroundColor: "#007bff",
											color: "white",
											border: "none",
											cursor: "pointer",
											transition: "background-color 0.3s ease"
										}}
										onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
										onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}
									>
                                    Envoyer

									</button>
								</form>


							</div>
							<div className="confirmation-info" style={{
								fontSize: '0.85rem',
								color: '#666',
								padding: '10px 15px',
								borderRadius: '5px',
								maxWidth: '500px',
								margin: '0 auto 30px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center'
							}}>
								<div style={{
									marginRight: '10px',
									color: '#007bff',
									fontSize: '1.2rem'
								}}>

								</div>
								<p style={{ margin: 0 }}>

								</p>
							</div>
						</div>
					</div>

			{/* <div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<div className="heading1-w">
							<h2>Abonnez à notre NewLetter .</h2>
							<p className="mt-16">Ne manquez plus aucune information grace à notre newletters .</p>
							<div className="form-area">
								<form action="#">
									<input type="email" placeholder="Veillez saisir votre Email" />
									<div className="button">
										<button className="theme-btn1">Envoyer</button>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div className="col-lg-6">
						<div className="image text-end sm:text-start md:text-start sm:mt-30 md:mt-30">
							{/* <img  src={`${process.env.PUBLIC_URL}/assets/img/hero/hero_img.png`} alt="vexon" /> */}
						{/* </div>
					</div>
				</div>
			</div>  */}
		</div>
		</div>

		</div>
		</div>

        </footer1>
    );
}

export default Footer1;
